import type { BundledPackageStateToVehicleId } from "@b2bportal/core-packages";
import type { FiatPrice, VehicleAvailability } from "@b2bportal/ground-api";

/**
 * Gets the incremental price for a package car
 * Returns the incremental price if available, otherwise falls back to total charge
 */
export const getPackageCarPrice = (
  car: VehicleAvailability,
  packageStateByVehicleId?: BundledPackageStateToVehicleId
): FiatPrice | null => {
  if (!packageStateByVehicleId) {
    return car.totalCharge?.fiat ?? null;
  }

  const packageState = packageStateByVehicleId[car.vehicle.id];
  return (
    packageState?.price.incrementalChange?.fiat ?? car.totalCharge?.fiat ?? null
  );
};
